import asyncActionTypes from '../actions/types.js';

const initialState = {
  loading: false,
  menuPromotions: {},
};

const menuPromotions = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CMS_MENU_PROMOTIONS.START:
      return {
        ...state,
        loading: true,
      };
    case asyncActionTypes.RETRIEVE_CMS_MENU_PROMOTIONS.SUCCESS:
      const menuPromotion = Object.entries(action.payload).length !== 0 ? action.payload[0] : {};

      return {
        ...state,
        loading: false,
        menuPromotions: menuPromotion,
      };
    case asyncActionTypes.RETRIEVE_CMS_MENU_PROMOTIONS.FAIL:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default menuPromotions;
